import { h, Host } from "@stencil/core";
import { attachSlottedCss, injectCSS } from "../../utils";
import { createStyles, getSlottedCss } from "./image-styles";
export class DcUiImageWrapper {
    connectedCallback() {
        attachSlottedCss(this.el, getSlottedCss(this.el, this.ratio, this.imageStyle, this.objectFit));
    }
    render() {
        injectCSS(this.el, createStyles);
        return (h(Host, { key: '3d8d5a58c7256962569ccf102558fb0954c59ce9' }, h("slot", { key: '2fa6a837e869f2f86939f9ce2861e674c3f25827' })));
    }
    static get is() { return "dc-ui-image-wrapper"; }
    static get encapsulation() { return "shadow"; }
    static get properties() {
        return {
            "imageStyle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TImageStyle",
                    "resolved": "string",
                    "references": {
                        "TImageStyle": {
                            "location": "import",
                            "path": "./image-utils",
                            "id": "src/components/dc-ui-image-wrapper/image-utils.ts::TImageStyle"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "image-style",
                "reflect": false
            },
            "objectFit": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TImageObjectFit",
                    "resolved": "string",
                    "references": {
                        "TImageObjectFit": {
                            "location": "import",
                            "path": "./image-utils",
                            "id": "src/components/dc-ui-image-wrapper/image-utils.ts::TImageObjectFit"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "object-fit",
                "reflect": false
            },
            "ratio": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "ratio",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=dc-ui-image-wrapper.js.map
